import pluralize from 'pluralize'

function getRemixCopy(count = 0) {
  return pluralize('remix', count, true)
}

export { getRemixCopy }
